// export class IngresoActivoFijoFuncionario {
//     fechaIngresoActivo: Date;
//     fechaSalidaActivo: Date;
//     idActivoFijo: number;
//     idDependencia: number;
//     idGrupoDiscapacidad: number;
//     nombreCompleto: string;
//     nombreDependencia: string;
//     numeroIdFuncionario: string;
//     sede: string;
//     tipoFuncionario: string;
//     tipoIdFuncionario: string;
//     urlFoto: string;
//     usuarioSIA3: string;
//     correo: string;

//     constructor() {}
// }

export class IngresoActivoFijoFuncionario {
  fechaIngresoActivo: Date;
  fechaSalidaActivo: Date;
  idActivo: number;
  idDependencia: number;
  idGrupoDiscapacidad: number;
  nombreCompleto: string;
  nombreDependencia: string;
  numeroIdFuncionario: string;
  sede: string;
  tipoFuncionario: string;
  tipoIdFuncionario: string;
  urlFoto: string;
  usuarioSIA3: string;
  correo: string;
  idUsuarioSIA3?: number;
  tipo?: string;
  serialActivoFijo?: string;
  descripcion?: string;
  estado?: string;
  clasificacion?: string;
  cual?: string;
  marca?: string;
  placaInventario?: string;
  autorizadoPor?: string;
  observaciones?: string;
  perteneceA?: string;
  estadoActivo?: string;
  observacionesIngresoSalida?: string;
  constructor() { }
}


